export default __webpack_public_path__ + "static/media/calendarRight.0faa30d5.svg";